/**
 * Screen help of a main screen (CZNA-1509), rendered inside the `<PaneHelpButton>` popover
 * of Inbox, Všechny kontroly, Autority, Rejstříky, Slovníky and Sklizeň OAI (CZNA-1562).
 *
 * The layout lives here and the wording in the translations, one message per intro and per
 * bullet, so NK rewords any of them in Nastavení → Texty nápovědy as plain text: the override layer
 * accepts no markup, which is why the title, the headings and the bold lead terms are
 * separate non-help messages instead of tags inside one text. Same shape as
 * `DerivationHelpContent`.
 *
 * Message ids follow `nav.<screen>.<item>` (lead term) next to `nav.<screen>.help.<item>`
 * (its text), so the help-text editor labels each row with the lead term it explains
 * (`labelCandidates` in `settings/helpTextCatalog.ts`).
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Headline } from '@folio/stripes/components';
var sectionStyle = { marginTop: '0.75rem' };
var listStyle = { margin: 0, paddingLeft: '1.25rem' };
var ScreenHelp = function (_a) {
    var spec = _a.spec;
    return (React.createElement("div", { "data-testid": "screen-help-content", style: { fontSize: '0.9em' } },
        React.createElement(Headline, { size: "medium", margin: "none", tag: "h3" },
            React.createElement(FormattedMessage, { id: spec.title })),
        React.createElement("div", { style: { marginTop: '0.25rem' } },
            React.createElement(FormattedMessage, { id: spec.intro })),
        spec.sections.map(function (section) { return (React.createElement("div", { key: section.heading, style: sectionStyle },
            React.createElement(Headline, { size: "small", margin: "xx-small", tag: "h4" },
                React.createElement(FormattedMessage, { id: section.heading })),
            React.createElement("ul", { style: listStyle }, section.items.map(function (item) { return (React.createElement("li", { key: item.text },
                React.createElement("strong", null,
                    React.createElement(FormattedMessage, { id: item.term })),
                ' — ',
                React.createElement(FormattedMessage, { id: item.text }))); })))); })));
};
export default ScreenHelp;
